"use client";
import React, { Suspense } from "react";
import { VStack } from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { PRICING_HEADING_CONSTANTS } from "./constants";
import { tablist } from "./pricingTabsList";

const PricingTabs = () => {
  const headingVariant = useHeadingVariant();
  return (
    <VStack id={"vdi-pricing"} gap={4}>
      <Heading as="h1" variant={headingVariant}>
        {PRICING_HEADING_CONSTANTS.title}
      </Heading>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 2 }} tabList={tablist} />
      </Suspense>
    </VStack>
  );
};

export default PricingTabs;
